import { hasSelectedFacets } from "../../../filters/selectors";
import { getProducts } from "../../../results/selectors";
import { getIsSearchPage } from "../../../../../page/selectors";

const shouldRedirect = (state) => {
  const products = getProducts(state);

  return ![
    products.length !== 1,
    hasSelectedFacets(state),
    !getIsSearchPage(state),
  ].some((result) => result);
};

export default shouldRedirect;
